/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Sparte {

    Kfz = 'Kfz',

    Rlv = 'Rlv',

    Bu = 'Bu',

    Pr = 'Pr',

    Br = 'Br',

    Kvv = 'Kvv',

    Kvz = 'Kvz',

    Wg = 'Wg',

    Hr = 'Hr'
}

